var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInActiveuser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4421,
    cy: 23.1886,
    r: 22.8526,
    fill: "#FF2F6D",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4834 18.7061C28.4834 21.5027 26.2411 23.7451 23.4425 23.7451C20.6448 23.7451 18.4016 21.5027 18.4016 18.7061C18.4016 15.9095 20.6448 13.668 23.4425 13.668C26.2411 13.668 28.4834 15.9095 28.4834 18.7061ZM23.4423 32.7118C19.312 32.7118 15.8248 32.0405 15.8248 29.4505C15.8248 26.8596 19.334 26.2121 23.4423 26.2121C27.5735 26.2121 31.0598 26.8834 31.0598 29.4734C31.0598 32.0643 27.5507 32.7118 23.4423 32.7118Z",
    fill: "#FF2F6D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveuser);
export default __webpack_public_path__ + "static/media/inActiveuser.67b738b1dbb3c0b92890c2e2632b1cd6.svg";
export { ForwardRef as ReactComponent };